import axios from "axios";
import config from "./config";

const axiosInstance = axios.create({
  baseURL: config.api.ENDPOINT,
  responseType: "json",
  withCredentials: true,
});

axiosInstance.interceptors.request.use(config => {
  config.headers['X-Psb-Tz'] = Intl.DateTimeFormat().resolvedOptions().timeZone;
  return config;
});

export default axiosInstance;